import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import BaseAnswer from '../base-answer';
import { AnswerProvider, FeedbackAnswerSurvey } from '../../providers/answer-provider';
import { FeedbackQuestionSurvey } from '../../providers/question-provider';
import { Human } from '../../human';
import { FeedbackQuestionFactoryService } from '../../questions/feedback-question-factory.service';
import { FeedbackQuestionService } from '../../questions/feedback-question.service';
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatTab, MatTabGroup, MatTabsModule } from "@angular/material/tabs";
import { TranslateModule } from "@ngx-translate/core";
import { MatSlider, MatSliderModule } from "@angular/material/slider";
import { NgForOf, NgIf } from "@angular/common";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatButton, MatButtonModule } from "@angular/material/button";
import { Feedback } from "../../../common/models/feedback";
import { FormControl, ReactiveFormsModule } from "@angular/forms";

@Component({
  selector: 'app-feedback-hurt-answer',
  templateUrl: 'feedback-hurt-answer.component.html',
  styleUrls: ['./feedback-hurt-answer.css', './../feedback-answer.css'],
  imports: [
    FlexLayoutModule,
    MatTabGroup,
    MatTabsModule,
    TranslateModule,
    MatSliderModule,
    NgIf,
    MatIconModule,
    MatButtonModule,
    NgForOf,
    ReactiveFormsModule,
  ],
  standalone: true
})
export class FeedbackHurtAnswerComponent extends BaseAnswer implements OnInit {

  @Input()
  public override hasAnsweredQuestion = false;

  @Input()
  public override feedback: Feedback = {} as Feedback;

  @Input()
  public override question: FeedbackQuestionSurvey = {} as FeedbackQuestionSurvey;

  @Input()
  public override previousAnswers: any = null;

  @Input()
  public answeredAnswers: any = null;

  @Output()
  public override onAnswerChange: EventEmitter<any> = new EventEmitter();

  @Output()
  public override onNextQuestionClicked: EventEmitter<{answers: FeedbackAnswerSurvey[]; isBack: boolean}> = new EventEmitter();

  public selectedAnswers: any[] = [];

  public sliderValue = 0;
  public sliderControl: FormControl = new FormControl(0);

  public activeFeedbackAnswer: FeedbackAnswerSurvey = {} as FeedbackAnswerSurvey;
  public activePath: Path | undefined = {} as Path;

  public backPaths: Path[] = Human.backPaths;
  public frontPaths: Path[] = Human.frontPaths;

  constructor(
    public override answerProvider: AnswerProvider,
    public override feedbackQuestionFactoryService: FeedbackQuestionFactoryService,
    public override feedbackQuestionService: FeedbackQuestionService,
  ) {
    super(answerProvider, feedbackQuestionFactoryService, feedbackQuestionService);
  }

  public override ngOnInit(): void {
    super.ngOnInit();

    this.sliderControl = new FormControl(this.sliderValue);
    this.sliderControl.valueChanges.subscribe(value => {
      this.onSliderChange({ value });
    });

    // find all answers for this question
    const data: any = this.feedbackQuestionService.getAnsweredAnswersByQuestionId(this.question['id']);
    this.selectedAnswers = data && data['answers'].length > 0 ? data['answers'] : null;

    this.subscriptions.push(
      this.feedbackAnswersPopulatedEvent.subscribe(() => {
        if (this.selectedAnswers && this.selectedAnswers.length > 0) {
          this.selectedAnswers.forEach((answer) => {
            const paths = [...this.frontPaths, ...this.backPaths];

            this.activePath = paths.find((x:any) => x['identifier'] === answer.data);

            this.activeFeedbackAnswer = answer;
            this.activeFeedbackAnswer.userData = answer.userData;
            this.changeBodyPartColor(answer.userData);
            this.answerChanged(answer, false);

            // add answered value to answers array
            const a = this.feedbackAnswers.find((x:any) => x['data'] === answer.data);
            if (a)
              a.userData = answer.userData;
          });
        }
      })
    );
  }

  public changePath(path: any, answer: any) {
    this.activeFeedbackAnswer = answer;
    this.activePath = path;

    this.sliderValue = this.activeFeedbackAnswer.userData ? +this.activeFeedbackAnswer.userData : 0;
    this.sliderControl.setValue(this.sliderValue, { emitEvent: false });

    this.blinkColor(path);
  }

  public onSliderChange(event: any): void {
    if (null === this.activeFeedbackAnswer) {
      this.sliderValue = 0;
      return;
    }

    this.activeFeedbackAnswer.userData = event.value;
    this.changeBodyPartColor(event.value);
  }

  public findByData(feedbackAnswers:any, data:any) {
    return feedbackAnswers.find((x:any) => x.data === data);
  }

  public override isNextQuestionEnabled(): boolean {
    let isEnabled = false;
    if (this.userAnswers.length === 0) {
      return isEnabled;
    }

    for (const userAnswer of this.userAnswers) {
      if (userAnswer.userData && parseInt(userAnswer.userData, 10) > 0) {
        isEnabled = true;
      }
    }

    return isEnabled;
  }

  private changeBodyPartColor(value = 0) {
    if (!this.activePath) {
      return;
    }
    this.activePath.fill = Human.colors[value];
  }

  private blinkColor(path: Path) {
    (async () => {
      if (path.fill === '#cfcfcf') {
        path.fill = '#c29d4d';
      }

      await new Promise( (resolve) => setTimeout(resolve, 1000) );

      if (path.fill === '#c29d4d') {
        path.fill = '#cfcfcf';
      }
    })();
  }
}

interface Path {
  path: string;
  identifier: string;
  borderSize?: number;
  borderColor?: string;
  x?: number;
  y?: number;
  fill?: string;
}
